import { Axios } from "index";

export const coreItemSrnoDropdownApi = "/core-inventory/item-srno-dropdown";
export const coreInwardSrnoDropdownApi = "/core-inventory/inward-srno-dropdown";

//Approval
export const fetchCoreApprovalApi = `/approval/core-approval-invoice-listing`;
export const fetchCoreItemsApprovalApi = function (id, invoice_id) {
  return `/approval/core-approval-item-listing-by-invoice/${id}/${invoice_id}`;
};
export const coreApproveInvoiceApi = function (id, invoice_id) {
  return `/approval/core-approve_invoice_details/${id}/${invoice_id}`;
};
export const coreRejectInvoiceApi = function (id, invoice_id) {
  return `/approval/core-reject_invoice_details/${id}/${invoice_id}`;
};

export const fetchCoreInwardNo = async (id) => {
  const res = await Axios.get(`/core-inventory/inward-sr-no-dropdown/${id}`);
  return res;
};
export const fetchCoreNoDropdown = async (id, itemId) => {
  const res = await Axios.get(
    `/core-inventory/item-sr-no-dropdown/${id}/${itemId}`
  );
  return res;
};
export const fetchCoreNoById = async (id) => {
  const res = await Axios.get(`/core-inventory/list-core-details/${id}`);
  return res;
};

export const addRawOrderCore = async (data) => {
  const res = await Axios.post("/order/issue-raw-core-order/issue-order", data);
  return res;
};
export const revertRawOrderCore = async (id) => {
  const res = await Axios.post(`/order/revert-order/${id}`);
  return res;
};
